import i18next from "i18next";
import Backend from "i18next-http-backend";

/**
 * Dedicated i18n instance for the public order form (`/order/:identifier`).
 *
 * It is intentionally isolated from the app's global i18n instance:
 *  - No LanguageDetector, so the form's language is never read from or written
 *    to localStorage (`i18nextLng`). Previously the form called
 *    `changeLanguage` on the global instance, which persisted the choice and
 *    leaked the form's language into the authenticated app running in the same
 *    tab (and forced every namespace to reload).
 *  - Only the namespaces the form actually uses (`order_form`, `common`).
 *
 * Wrapped around the public route via <I18nextProvider> in App.tsx.
 * Do not register initReactI18next here: it replaces the global React i18n
 * instance used by authenticated screens, bypassing their language detector.
 */
const i18nPublic = i18next.createInstance();

i18nPublic.use(Backend).init({
  lng: "en",
  fallbackLng: "en",
  debug: false,
  ns: ["order_form", "common"],
  defaultNS: "order_form",
  backend: {
    requestOptions: { cache: "no-cache" },
  },
  interpolation: {
    escapeValue: false,
  },
});

export default i18nPublic;
